import { render } from "./ProposalSummary.vue?vue&type=template&id=5a1e0276&scoped=true"
import script from "./ProposalSummary.vue?vue&type=script&lang=js"
export * from "./ProposalSummary.vue?vue&type=script&lang=js"

import "./ProposalSummary.vue?vue&type=style&index=0&id=5a1e0276&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a1e0276"]])

export default __exports__